import React, { useEffect, useState } from 'react';

import { Dialog, DialogContent, DialogActions, DialogTitle, Typography, Button, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { useAlertSound } from '@shared/context/AlertSoundContext';
import api from '@shared/api/api';

const useStyles = makeStyles((theme) => ({
  title: {
    display: 'flex',
    direction: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginRight: theme.spacing(4),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  countdown: {
    marginTop: theme.spacing(2),
    color: theme.palette.error.main,
    fontWeight: 'bold',
  },
}));

export const AutoStopAt8PMModal = (props) => {
  const { openModal, handleCloseModal, handleStopActivity, activityId } = props;
  const classes = useStyles();
  const [secondsRemaining, setSecondsRemaining] = useState(120);
  const playAlert = useAlertSound();

  const handleContinueActivity = async () => {
    if (activityId) {
      try {
        await api.continueActivityAfterClosing(activityId);
      } catch (error) {
        console.error('Erreur lors de la mise à jour de is_running_after_closing:', error);
      }
    }
    handleCloseModal();
  };

  useEffect(() => {
    if (openModal) {
      setSecondsRemaining(120);

      // Jouer le son immédiatement puis toutes les 5 secondes
      console.log('AutoStopAt8PMModal: Playing alert sound');
      playAlert();
      const soundInterval = setInterval(() => {
        console.log('AutoStopAt8PMModal: Playing alert sound (interval)');
        playAlert();
      }, 5000);

      const stopTimeOut = setTimeout(() => {
        handleStopActivity();
      }, 120000);

      const countdownInterval = setInterval(() => {
        setSecondsRemaining((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => {
        clearTimeout(stopTimeOut);
        clearInterval(countdownInterval);
        clearInterval(soundInterval);
      };
    }
  }, [openModal, handleStopActivity, playAlert]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div>
      <Dialog open={openModal} onClose={handleCloseModal} aria-labelledby="form-dialog-title">
        <DialogTitle disableTypography>
          <Typography variant="h6" className={classes.title}>
            Arrêt automatique à 20h
          </Typography>

          <IconButton aria-label="close" className={classes.closeButton} onClick={handleContinueActivity}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Typography>
            Il est 20h. Votre activité sera automatiquement arrêtée dans {formatTime(secondsRemaining)} si vous ne
            confirmez pas que vous souhaitez continuer.
          </Typography>
          <Typography className={classes.countdown}>
            Temps restant : {formatTime(secondsRemaining)}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleContinueActivity} color="primary" variant="contained">
            Continuer l'activité
          </Button>
          <Button onClick={handleStopActivity} color="secondary">
            Arrêter l'activité maintenant
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
